export default __webpack_public_path__ + "static/mainHero-183124608d4a6eb4889589c800abe90c.jpg";